import { TYPES_PACKAGE } from '@/redux/subscription/package.types';
import { SERVICE_SUBSCRIPTION } from '@/services/subscription.service';

const getSubcriptionPackage = () => {
  return (dispatch, getState) => {
    const { package: packageState } = getState();
    if (packageState.list.data || packageState.list.loading) {
      console.log("getSubcriptionPackage: Skipping fetch, data exists or loading.");
      return;
    }

    console.log("getSubcriptionPackage: Fetching...");
    dispatch({ type: TYPES_PACKAGE.GET_PACKAGE_DATA_LOADING, loading: true });

    SERVICE_SUBSCRIPTION.getSubcriptionPackage((res) => {
      dispatch({ type: TYPES_PACKAGE.GET_PACKAGE_DATA_LOADING, loading: false });
      dispatch({
        type: TYPES_PACKAGE.GET_PACKAGE_LIST_DATA,
        payload: res.payload,
        error: res.error,
      });
    });
  };
};

const getHeroData = () => {
  return (dispatch, getState) => {
    const { package: packageState } = getState();
    if (packageState.hero.data || packageState.hero.loading) {
       console.log("getHeroData: Skipping fetch, data exists or loading.");
       return;
    }
    console.log("getHeroData: Fetching...");
    dispatch({ type: TYPES_PACKAGE.GET_SUBSCRIPTION_HERO_LOADING, loading: true });
    SERVICE_SUBSCRIPTION.getHeroSection((res) => {
      dispatch({ type: TYPES_PACKAGE.GET_SUBSCRIPTION_HERO_LOADING, loading: false });
      dispatch({ type: TYPES_PACKAGE.GET_SUBSCRIPTION_HERO_DATA, payload: res.payload, error: res.error });
    });
  };
};

const getFeatureData = () => {
   return (dispatch, getState) => {
    const { package: packageState } = getState();
    if (packageState.feature.data || packageState.feature.loading) {
      console.log("getFeatureData: Skipping fetch, data exists or loading.");
      return;
    }
    console.log("getFeatureData: Fetching...");
    dispatch({ type: TYPES_PACKAGE.GET_SUBSCRIPTION_FEATURE_LOADING, loading: true });
    SERVICE_SUBSCRIPTION.getFeatureSection((res) => {
      dispatch({ type: TYPES_PACKAGE.GET_SUBSCRIPTION_FEATURE_LOADING, loading: false });
      dispatch({ type: TYPES_PACKAGE.GET_SUBSCRIPTION_FEATURE_DATA, payload: res.payload, error: res.error });
    });
  };
};

const getOfferData = () => {
  return (dispatch, getState) => {
    const { package: packageState } = getState();
    if (packageState.offer.data || packageState.offer.loading) {
      console.log("getOfferData: Skipping fetch, data exists or loading.");
      return;
    }
    console.log("getOfferData: Fetching...");
    dispatch({ type: TYPES_PACKAGE.GET_SUBSCRIPTION_OFFER_LOADING, loading: true });
    SERVICE_SUBSCRIPTION.getOfferSection((res) => {
      dispatch({ type: TYPES_PACKAGE.GET_SUBSCRIPTION_OFFER_LOADING, loading: false });
      dispatch({ type: TYPES_PACKAGE.GET_SUBSCRIPTION_OFFER_DATA, payload: res.payload, error: res.error });
    });
  };
};

export const ACTION_SUBSCRIPTION = {
  getSubcriptionPackage,
  getHeroData,
  getFeatureData,
  getOfferData,
};
